import { Badge } from "@/components/ui/badge";

export function ExperienceHighlight() {
  return (
    <section className="py-20 relative" style={{ backgroundImage: "url(/lovable-uploads/4cd465d1-c024-4ac6-bee7-d3c62f20e145.png)", backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-10 items-center">
        {/* Left: Big number with image clipped text */}
        <div className="relative flex flex-col items-center text-center">
          <Badge className="mb-4 bg-yellow-400 text-black px-4 py-2 font-black tracking-wider rounded-full shadow">
            ESTABLISHED
          </Badge>
          <div
            className="select-none leading-none font-black bg-clip-text text-transparent mx-auto"
            style={{
              backgroundImage: `url('/lovable-uploads/ac6ee7c6-9461-4b48-b516-c6c428313506.png')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              WebkitBackgroundClip: "text" as any,
              WebkitTextStrokeWidth: "10px",
              WebkitTextStrokeColor: "#ffffff",
            }}
          >
            <div className="font-archivo text-[160px] xs:text-[220px] sm:text-[260px] md:text-[300px] lg:text-[340px] tracking-tight">
              2005
            </div>
          </div>
          <p className="mt-4 text-base sm:text-lg font-semibold text-white">
            Over 20 years of experience
          </p>
        </div>

        {/* Right: Title, blurb, bullet and CTA */}
        <div className="text-center flex flex-col items-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-secondary leading-tight mb-5">
            RecruitLook Hoops is the top independent basketball operation in the country.
          </h2>


          <p className="text-white leading-relaxed mb-6 max-w-2xl">
            We offer a full suite of products including High School Grassroots Circuit, Elite Camps, Recruiting Coverage, and Subscription Service.
          </p>

          {/* Four basketball images */}
          <div className="relative mt-8 z-30 max-w-5xl mx-auto mb-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
              <div className="aspect-[4/5]">
                <div className="border-2 border-secondary p-[3px] rounded-xl shadow-xl">
                  <div className="w-full h-full rounded-lg overflow-hidden bg-white">
                    <img src="/lovable-uploads/347f6a63-e8ab-4d6b-9b21-76029ed222df.png" alt="Basketball players in action" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
              <div className="aspect-[4/5]">
                <div className="border-2 border-secondary p-[3px] rounded-xl shadow-xl">
                  <div className="w-full h-full rounded-lg overflow-hidden bg-white">
                    <img src="/lovable-uploads/65accb98-8bc7-4ac4-a00f-6c53f52be1a6.png" alt="Basketball players in competitive action" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
              <div className="aspect-[4/5]">
                <div className="border-2 border-secondary p-[3px] rounded-xl shadow-xl">
                  <div className="w-full h-full rounded-lg overflow-hidden bg-white">
                    <img src="/lovable-uploads/2847dea9-8415-4b98-85f8-251db820a509.png" alt="Player performing dunk" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
              <div className="aspect-[4/5]">
                <div className="border-2 border-secondary p-[3px] rounded-xl shadow-xl">
                  <div className="w-full h-full rounded-lg overflow-hidden bg-white">
                    <img src="/lovable-uploads/9776d3a3-b89b-4608-bd59-4cae6304b46c.png" alt="Basketball player performing an impressive dunk" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
